class ReleaseRentWithoutInvoice {
    rentAmount;
    fee;
    feePercent;
    releasedAmount;
    iva;
    ivaPercent;
    nonVerifiableAmount;
    nonVerifiableAmountPercent;
    releasedAmountDetailed;
    constructor(data) {
        this.rentAmount = data.rentAmount;
        this.fee = data.fee;
        this.feePercent = data.feePercent;
        this.releasedAmount = data.releasedAmount;
        this.iva = data.iva;
        this.ivaPercent = data.ivaPercent;
        this.nonVerifiableAmount = data.nonVerifiableAmount;
        this.nonVerifiableAmountPercent = data.nonVerifiableAmountPercent;
        this.releasedAmountDetailed = data.releasedAmountDetailed;
    }
}
export default ReleaseRentWithoutInvoice;
